export const getProducts = state => state.productsR.products;
export const loading = state => state.productsR.loading;
export const loadMoreData = state => state.productsR.loadMoreData;
export const getError = state => state.productsR.error;
export const getSelectedMenuId = state => state.productsR.selectedMenuItemId;
export const getMenu = state => state.menuR.menu;
